module.exports = __webpack_public_path__ + "img/img19.7e6b727f.svg";